import {
  Component,
  ViewEncapsulation,
  ContentChildren,
  QueryList,
  ViewContainerRef,
  TemplateRef
} from "@angular/core";
import { TemplatePortal } from "@angular/cdk/portal";

import { HeaderBreadcrumbDirective } from "./header-breadcrumb.directive";

@Component({
  selector: "onsip-header-breadcrumb-container, onsip-breadcrumb-container",
  templateUrl: "header-breadcrumb-container.component.html",
  styleUrls: ["header-breadcrumb-container.component.scss"],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class HeaderBreadcrumbContainerComponent {
  @ContentChildren(HeaderBreadcrumbDirective, { read: TemplateRef }) set _breadcrumbs(
    breadcrumbs: QueryList<TemplateRef<HeaderBreadcrumbDirective>>
  ) {
    this.breadcrumbs = breadcrumbs.map(breadcrumb => new TemplatePortal(breadcrumb, this.vcRef));
  }
  breadcrumbs!: Array<TemplatePortal<HeaderBreadcrumbDirective>>;

  constructor(private vcRef: ViewContainerRef) {}
}
